module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAMAAAA0jaRDAAAAeFBMVEWQsfgsi4wtb0cthn5Th/RkfaCNiXaOi3uPjHWUkH2WkYGYk3+al4KhimOioJGt0KCyr6Oy1664tqq9u6/FwrjK5dPQ4tHT1MjU083V6trX1c7b2dDe4tXh4Nvh4Nzl5eDs6+Tz8/H6+vn7+vj7+/v8+/b8/Pz///8tPA9VAAAAAXRSTlPM0jRW/QAAAE9JREFUKM9jYCEEGIaOCsJAHQXICbHzyaMKoapQ5FTlVeZSwqNCWIKfVVBKBI8KaRlmJkZxKTwqVDhEJcV41PCoUFfgFmCTRXMpYTCM4hYAlrIhjIGPis8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ni.png
// module id = 893
// module chunks = 0